import { GetRefundPolicyUseCase } from '@/core/domain/refund-policy/usecases/getRefundPolicy.usecase';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { of, switchMap } from 'rxjs';

@Component({
    selector: 'fe-refunds-policy',
    templateUrl: './refunds-policy.component.html',
    styleUrls: ['./refunds-policy.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class RefundsPolicyComponent implements OnInit {
    public breadcrumbs = [
        {
            label: 'fe_breadcrumb_view_customer_support',
            url: 'contact-us-and-faqs',
        },
        {
            label: 'fe_breadcrumb_view_questions',
            url: 'questions',
        },
        {
            label: 'fe_breadcrumb_view_refund_policy',
            url: 'questions/refunds-policy',
        },
    ];

    public refundPolicyContent = '';

    constructor(
        private readonly getRefundPolicyUsecase: GetRefundPolicyUseCase,
    ) {}

    public ngOnInit(): void {
        this.getRefundPolicyUsecase
            .execute()
            .pipe(
                switchMap((response) => {
                    this.refundPolicyContent = response.data.refundPolicy;
                    return of(response);
                }),
            )
            .subscribe();
    }
}
